import axios from 'axios';

/**
 * Liste des actions
 */
export const Actions = {
    FETCH_INFOS_SUIVI_COLIS_REQUEST: 'FETCH_INFOS_SUIVI_COLIS_REQUEST',
    FETCH_INFOS_SUIVI_COLIS_SUCCESS: 'FETCH_INFOS_SUIVI_COLIS_SUCCESS',
    FETCH_INFOS_SUIVI_COLIS_FAILURE: 'FETCH_INFOS_SUIVI_COLIS_FAILURE'
};

const fetchInfosSuiviColisRequest = () => ({ type: Actions.FETCH_INFOS_SUIVI_COLIS_REQUEST });
const fetchInfosSuiviColisSuccess = infosSuiviColis => ({ type: Actions.FETCH_INFOS_SUIVI_COLIS_SUCCESS, infosSuiviColis });
const fetchInfosSuiviColisFailure = error => ({ type: Actions.FETCH_INFOS_SUIVI_COLIS_FAILURE, error });

export const fetchPieceInfosSuiviColis = (numeroPiece) => async (dispatch, getState) => {
    if (!getState().suiviColis.isInfosSuiviColisLoading) {
        // On regarde si le suivi cvolis n'existe pas déjà pour cette pièce.
        const suiviColis = getState().suiviColis.suivisColis.find(x => x.numeroPiece === numeroPiece);
        if (!suiviColis) {
            dispatch(fetchInfosSuiviColisRequest());

            try {
                let response = await axios.get(`api/pieces-gestion/${numeroPiece}/infos-suivi-colis`);

                dispatch(fetchInfosSuiviColisSuccess(response.data));
            } catch (error) {
                console.error('fetchInfosSuiviColis : ', error);
                dispatch(fetchInfosSuiviColisFailure(error));
            }
        }
    }

    return undefined;
};



